import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import CustomProgressBar from '../../../shared/components/CustomProgressBar'
import Clickable from '../Clickable'

import panelStyle from 'Styles/panel.css'
import progressBarStyle from 'Styles/progress-bar.css'
import style from './style.css'

import caretRight from 'Assets/caret-right-acqua.svg'
import caretDown from 'Assets/caret-down-acqua.svg'

import redDot from 'Assets/redDot.svg'
import yellowDot from 'Assets/yellowDot.svg'
import greenDot from 'Assets/greenDot.svg'
import iconStyle from 'Styles/icon.css'

function StudyPlanItemExpanded (props) {
  return (
    <div>
      <p className={style.topicTitle}>
        Study plan suggestions
      </p>
      <span className={props.studyPlan.length ? style.noItemsMsgDisabled : style.noItemsMsg}>
        No items available.
      </span>
      <ul className={style.suggestionList}>
        {_.map(props.studyPlan, item => {
          const itemClass = item.itemType === 'ebook' ? style.ebookItem : style.suggestionItem
          return (
            <li
              data-test-id="studyPlanItemSuggestions"
              className={itemClass}
              key={item.displayValue}
            >
              <Clickable
                className={props.disableLinks ? style.studyNameDisabled : style.studyName}
                onClick={props.disableLinks ? null : () => props.itemClick(item)}
                tabIndex="0"
              >
                <span dangerouslySetInnerHTML={{ __html: item.displayValue }} />
              </Clickable>
            </li>
          )
        })}

      </ul>
    </div>
  )
}
StudyPlanItemExpanded.propTypes = {
  studyPlan: PropTypes.array,
  disableLinks: PropTypes.bool,
  isStandalone: PropTypes.bool,
  itemClick: PropTypes.func.isRequired
}

function StudyPlanItemDisabled (props) {
  return (
    <div
      data-test-id="studyPlanItem"
      className={classnames(panelStyle.small, style.studyPanel, style.disabledPanel)}
    >
      <div
        data-test-id="studyPlanItemTitle"
        className={style.disabled}
        dangerouslySetInnerHTML={{ __html: props.label }}
      />
      <div className={style.disabledText}>
        Questions on this topic are hidden.
      </div>
    </div>
  )
}

StudyPlanItemDisabled.propTypes = {
  label: PropTypes.string.isRequired
}

function renderGradedDot (score) {
  let gradedDot = greenDot
  if (score < 70) {
    gradedDot = redDot
  } else if (score < 90) {
    gradedDot = yellowDot
  }

  const dotImg = score > 0
    ? (
    <img
      key={score}
      src={gradedDot}
      className={classnames(iconStyle.small)}
      alt=""
      tabIndex="-1"
      aria-hidden="true"
    />
      )
    : null

  return dotImg
}

function StudyPlanItemActive (props) {
  const percentage = props.totalPointsAvailable
    ? Math.round(props.totalPointsEarned / props.totalPointsAvailable * 100)
    : 0

  const percentageLabel = ((props.startedStudents !== null && props.startedStudents === 0) || percentage === 0)
    ? '-- '
    : percentage

  return (
    <div
      data-test-id="studyPlanItem"
      className={classnames(panelStyle.base, style.studyPanel)}
    >
      <Clickable
        data-test-id="studyPlanItemTitleBtn"
        onClick={props.onClick}
        aria-expanded={props.isExpanded}
        aria-label={'Study plan suggestions for ' + props.label}
      >
        {props.isExpanded
          ? <img aria-hidden="true" className={style.topicCaret} src={caretDown} alt="caret expanded" />
          : <img aria-hidden="true" className={style.topicCaret} src={caretRight} alt="caret collapsed" />
        }
        <div
          data-test-id="studyPlanItemTitle"
          className={style.topicText}
          dangerouslySetInnerHTML={{ __html: props.label }}
        />
      </Clickable>

      <Row>
        <Col xs={10} sm={10} md={9} lg={10}>
          <CustomProgressBar
            dataTestId="studyPlanItemProgressBar"
            now={percentage}
            min={0}
            max={100}
            ariaLabel={`You have ${percentage} points.`}
            progressBarStyle={progressBarStyle}
            style={style}
            className={classnames(progressBarStyle.base, style.progressBar)}
            bsClass={classnames(progressBarStyle.progressValueBase)}
          />
        </Col>
        <Col xs={2} sm={2} md={3} lg={2} className={style.accuracyCol}>
          <span className={style.percentage} data-test-id="topicAccuracy">
            {renderGradedDot(percentage)}
            <label className={classnames(iconStyle.textIcon, iconStyle.TopicPerformance)}>{percentageLabel}%</label>
          </span>
          <br className={classnames('hidden-sm', 'hidden-md', 'hidden-lg')} />
        </Col>
      </Row>
      {props.isExpanded
        ? <StudyPlanItemExpanded {...props} />
        : null
      }
    </div>
  )
}

StudyPlanItemActive.propTypes = {
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  itemClick: PropTypes.func,
  totalPointsAvailable: PropTypes.number.isRequired,
  totalPointsEarned: PropTypes.number.isRequired,
  studyPlan: PropTypes.array,
  disableLinks: PropTypes.bool,
  startedStudents: PropTypes.number
}

function StudyPlanItemContainer (props) {
  return props.isActive ? <StudyPlanItemActive {...props} /> : <StudyPlanItemDisabled {...props} />
}

StudyPlanItemContainer.propTypes = {
  isActive: PropTypes.bool
}

export default class StudyPlanItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isExpanded: false
    }
  }

  toggleStudyPlan () {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  render () {
    return (
      <StudyPlanItemContainer
        onClick={this.toggleStudyPlan.bind(this)}
        isExpanded={this.state.isExpanded}
        {...this.props}
      />
    )
  }
}
